import React, { useContext } from 'react'
import { FormField } from 'uiwidgets/FormField';
import { TenantContext } from '../tenant/TenantContext';
import { getPaymentSourceType } from 'util/Lookup';
import { SecurityContext } from 'security/SecurityContext';

const PaymentSourceTypeSelect = (props) => {
    const { businessConfig } = useContext(TenantContext);
    const secCtx = useContext(SecurityContext);
    return (
        <FormField name={props.name} label="Payment Source Type" type="select"
            placeholder="Payment Source Types" onChange={props.onChange} onBlur={props.onBlur}
            valstate={props.valstate} valMsg={props.valMsg}
            readOnly={props.readOnly}
            value={props.value}>
            <option value="">select payment source type</option>
            {businessConfig.busPmtSrcTypes.map((busPmtSrcType, idx) => {
                if ((busPmtSrcType.paymentSourceType === 'OFFLINE') && (!secCtx.authState)) {
                    return;
                } else {
                    return (
                        <option value={busPmtSrcType.paymentSourceType} key={idx}>{getPaymentSourceType(busPmtSrcType.paymentSourceType)}</option>
                    );
                }
            })}
        </FormField>

    )
}
export default PaymentSourceTypeSelect